/**
 * DashboardSidebar - Navigation persistent giua cac /dashboard/* route.
 *
 * Reuse cho Hub + Social + Agents + future PLANNED dashboard.
 * Responsive:
 *  - Desktop (>= 960px): left sidebar 220px width.
 *  - Mobile (< 960px): top horizontal tab strip cuon ngang.
 *
 * Highlight active route via react-router useLocation.
 *
 * Per founder feedback 2026-05-12 muc 1: vao 1 dashboard khong co cach back ve Hub
 * hoac switch sang dashboard khac. Sidebar liet ke dashboard LIVE + PLANNED critical.
 *
 * Spec patch: F-A-DASHBOARD-HUB.md + F-A-AGENT-DASHBOARD.md 2026-05-12-v2.
 * Patch 2026-05-12 v3: bo MD-26 (merged MD-29), an MD-24 + MD-9 (no value Phase 0).
 * DECISIONS: s2026-05-12-HUB-PRUNE-MD26-MERGE-MD29.
 */

import { Link, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

interface NavItem {
  path: string;
  label: string;
  status: 'LIVE' | 'PLANNED';
  module: string;
}

// Patch 2026-05-12 (DECISIONS s2026-05-12-HUB-PRUNE-MD26-MERGE-MD29):
// - BO MD-26 Social Insight standalone (merged vao MD-29).
// - AN MD-24 News Pipeline + MD-9 Doc Pack admin (no value Phase 0).
// - GIU 3 PLANNED roadmap critical: MD-25 SEO, MD-COST, MD-15 Eval gold-50.
const NAV_ITEMS: NavItem[] = [
  { path: '/dashboard', label: 'Tong quan (Hub)', status: 'LIVE', module: 'MD-27' },
  { path: '/dashboard/agents', label: 'Agents + Cron', status: 'LIVE', module: 'MD-28' },
  { path: '/dashboard/content', label: 'Quan ly noi dung', status: 'LIVE', module: 'MD-29' },
  { path: '/dashboard/seo', label: 'SEO Bootstrap', status: 'LIVE', module: 'MD-25' },
  { path: '/dashboard/cost', label: 'Chi phi ha tang', status: 'PLANNED', module: 'MD-COST' },
  { path: '/dashboard/eval', label: 'Eval gold-50', status: 'PLANNED', module: 'MD-15' },
];

function isActive(currentPath: string, itemPath: string): boolean {
  if (itemPath === '/dashboard') return currentPath === '/dashboard' || currentPath === '/dashboard/';
  return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);
}

function SidebarNavList() {
  const location = useLocation();
  return (
    <nav className="dashboard-sidebar-nav" aria-label="Dieu huong bang dieu khien">
      <ul className="dashboard-sidebar-list">
        {NAV_ITEMS.map((item) => {
          const active = isActive(location.pathname, item.path);
          const baseCls = `dashboard-sidebar-item dashboard-sidebar-item-${item.status.toLowerCase()}`;
          const activeCls = active ? ' dashboard-sidebar-item-active' : '';
          if (item.status === 'PLANNED') {
            return (
              <li key={item.path} className={`${baseCls}${activeCls}`}>
                <span
                  className="dashboard-sidebar-link dashboard-sidebar-link-disabled"
                  aria-disabled="true"
                  title="Chua mo"
                >
                  <span className="dashboard-sidebar-label">{item.label}</span>
                  <span className="dashboard-sidebar-tag">Sap ra mat</span>
                </span>
              </li>
            );
          }
          return (
            <li key={item.path} className={`${baseCls}${activeCls}`}>
              <Link
                to={item.path}
                className="dashboard-sidebar-link"
                aria-current={active ? 'page' : undefined}
              >
                <span className="dashboard-sidebar-label">{item.label}</span>
                <span className="dashboard-sidebar-module">{item.module}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

interface DashboardShellProps {
  children: ReactNode;
}

/**
 * Wrap layout cho moi /dashboard/* route. Cap sidebar persistent ben trai (desktop)
 * hoac top tab strip (mobile).
 */
export function DashboardLayout({ children }: DashboardShellProps) {
  return (
    <div className="dashboard-layout">
      <aside className="dashboard-sidebar" aria-label="Sidebar bang dieu khien">
        <div className="dashboard-sidebar-head">
          <Link to="/dashboard" className="dashboard-sidebar-brand">
            Asklaw Admin
          </Link>
          <p className="dashboard-sidebar-sub">Phase 0 noi bo</p>
        </div>
        <SidebarNavList />
        <div className="dashboard-sidebar-foot">
          <a href="/" className="dashboard-sidebar-back">Ve trang chu</a>
        </div>
      </aside>
      <div className="dashboard-layout-main">{children}</div>
    </div>
  );
}
